// extracted by mini-css-extract-plugin
module.exports = {"sideAndMain":"SideAndMainLayout_sideAndMain__sl1xq","aside":"SideAndMainLayout_aside__3tdBE","old":"SideAndMainLayout_old__19Y2b","main":"SideAndMainLayout_main__tAgFw"};